// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pgxtcckqwcwvwkbtlksa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBneHRjY2txd2N3dndrYnRsa3NhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ4NzU0ODYsImV4cCI6MjA1MDQ1MTQ4Nn0.g4qlOZqX31NRP4nUvDr3XI0BF3hQTpnSkrkhYHXBWbI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);